import React from 'react';
import { IconButton as MuiIconButton, IconButtonProps } from '@mui/material';
import * as styles from '@components/iconButton/IconButton.styles';

export interface IIconButton extends IconButtonProps {
  variant?: 'circular' | 'circularDark' | 'rounded';
}

const iconStyle: Record<string, object> = {
  circular: styles.circularStyle,
  circularDark: styles.circularDarkStyle,
  rounded: styles.roundedStyle,
};

export const IconButton = React.forwardRef<HTMLButtonElement, IIconButton>((props, ref) => {
  const { variant = 'circular', children, sx, ...other } = props;

  return (
    <MuiIconButton ref={ref} sx={[iconStyle[variant], { ...sx }]} {...other}>
      {children}
    </MuiIconButton>
  );
});

IconButton.displayName = 'IconButton';
